/// <amd-module name="typeahead/core/message/SuggestionReadyMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionResult} from "typeahead/core/Suggestion";

/* SuggestionReady message is published in any one of the below cases -
     a) just before suggestions are displayed
     b) ess response returns zero suggestions with response code anything other than 'ZERO_RESULT_BY_EXCEPTION'
     c) ess response returns non zero suggestions but are not shown since they arrive late (user types too fast)
     d) just before Google autocomplete suggestion displayed
     e) just before Current Location suggestion displayed
*/
export class SuggestionReadyMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestion_ready";
    }

    constructor(private query: string, private suggestions: ISuggestionResult[], private activeEssTests: string,
                private domElementId: string, private metadata: string) {}

    public getTopic(): string {
        return SuggestionReadyMessage.getTopic();
    }

    public getQuery(): string {
        return this.query;
    }

    public getSuggestions(): ISuggestionResult[] {
        return this.suggestions;
    }

    public getActiveEssTests(): string {
        return this.activeEssTests;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getMetadata(): string {
        return this.metadata;
    }
}
